import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useWA, useLoad, PageHead, Card, Btn, Badge, Skeleton, Empty, ErrorBox, Search, fdate } from "../ui";
import { siteLink } from "../api";

const BUILTIN = [
  ["about", "About Us", "/about"],
  ["terms", "Terms & Conditions", "/terms"],
  ["privacy", "Privacy Policy", "/privacy-policy"],
];

function Overrides({ pages }) {
  const { api, run } = useWA();
  const [ov, setOv] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api("settingsGet").then((r) => setOv(r.settings.overrides)).catch(() => null);
  }, [api]);
  if (!ov) return null;
  const save = async () => {
    setBusy(true);
    try {
      await run("settingsSave", { section: "overrides", value: ov }, "Built-in pages की setting save हो गई");
    } catch (e) {
      /* toast */
    }
    setBusy(false);
  };
  return (
    <Card title="About / Terms / Privacy" subtitle="ये pages पहले से design किए हुए हैं। इनकी जगह अपना लिखा page दिखाना हो तो यहाँ चुनें।" icon="fa-solid fa-shuffle" className="mb-5"
      actions={<Btn variant="primary" icon="fa-solid fa-floppy-disk" loading={busy} onClick={save}>Save</Btn>}>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {BUILTIN.map(([k, label, path]) => (
          <div key={k} className="rounded-2xl border wa-line p-3.5">
            <div className="flex items-center justify-between mb-2">
              <p className="font-semibold text-sm">{label}</p>
              <a href={siteLink(path)} target="_blank" rel="noreferrer" className="text-[11px] wa-muted hover:underline">{path} ↗</a>
            </div>
            <select className="wa-input" value={ov[k] || ""} onChange={(e) => setOv({ ...ov, [k]: e.target.value })} aria-label={label}>
              <option value="">पहले वाला design (default)</option>
              {pages.map((p) => <option key={p.id} value={p.slug}>{p.title} (/{p.slug})</option>)}
            </select>
          </div>
        ))}
      </div>
    </Card>
  );
}

export default function Pages() {
  const nav = useNavigate();
  const { run, confirm } = useWA();
  const [q, setQ] = useState("");
  const { data, loading, error, reload } = useLoad("pages");
  const all = (data && data.items) || [];
  const items = all.filter((p) => !q || (p.title + " " + p.slug).toLowerCase().includes(q.toLowerCase()));

  const del = async (p) => {
    if (!(await confirm({ title: `"${p.title}" page delete करें?`, text: `ycnp.in/${p.slug} खुलना बंद हो जाएगा।`, danger: true }))) return;
    try {
      await run("pageDelete", { id: p.id }, "Page delete हो गया");
      reload();
    } catch (e) {
      /* toast */
    }
  };

  return (
    <div>
      <PageHead icon="fa-regular fa-file-lines" title="Pages" subtitle="वेबसाइट के अलग pages — जैसे FAQ, Refund policy, Help" actions={<Btn variant="primary" icon="fa-solid fa-plus" onClick={() => nav("/website/pages/new")}>नया Page</Btn>} />
      {data && <Overrides pages={all} />}
      <ErrorBox msg={error} retry={reload} />
      <Card pad={false} title="सारे pages" subtitle={`${all.length} pages`} actions={<Search value={q} onChange={setQ} placeholder="Page खोजें…" className="w-64" />}>
        {loading && !data ? <div className="p-4"><Skeleton rows={5} /></div> : !items.length ? (
          <Empty icon="fa-regular fa-file" title="कोई page नहीं" action={<Btn variant="primary" icon="fa-solid fa-plus" onClick={() => nav("/website/pages/new")}>नया Page</Btn>} />
        ) : (
          <div className="overflow-x-auto">
            <table className="wa-tbl">
              <thead><tr><th>Page</th><th>Address</th><th className="hidden md:table-cell">बदला</th><th /></tr></thead>
              <tbody>
                {items.map((p) => (
                  <tr key={p.id}>
                    <td><Link to={`/website/pages/${p.id}`} className="font-semibold hover:underline">{p.title}</Link>{p.seoDescription && <p className="text-[11.5px] wa-muted line-clamp-1 max-w-md">{p.seoDescription}</p>}</td>
                    <td><a href={siteLink("/" + p.slug)} target="_blank" rel="noreferrer" className="text-[12.5px] hover:underline" style={{ color: "var(--wa-accent)" }}>/{p.slug}</a>{["about", "terms", "privacy-policy"].includes(p.slug) && <Badge tone="amber" className="ml-2">built-in route</Badge>}</td>
                    <td className="hidden md:table-cell wa-muted text-[12.5px]">{fdate(p.updatedAt)}</td>
                    <td className="text-right whitespace-nowrap">
                      <Btn size="sm" icon="fa-regular fa-pen-to-square" onClick={() => nav(`/website/pages/${p.id}`)} aria-label="Edit" />
                      <Btn size="sm" className="ml-1 !text-rose-600" icon="fa-regular fa-trash-can" onClick={() => del(p)} aria-label="Delete" />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>
    </div>
  );
}
